/** @jsxImportSource @emotion/react */
import InfoTip, {P} from './info-tip';

const WebIPLimitInfo = function () {
  return (
    <InfoTip
      info={
        <section css={{width: 292}}>
          <P>
            藉由設定固定 IP 位置，限定員工在指定地點使用網頁版進行上下班打卡。
          </P>
          <P className="!mb-0">
            例如：設定辦公室固定 IP 位置，表示員工必須利用辦公室網路並在網頁版完成打卡。
          </P>
        </section>
      }
    />
  );
};

export default WebIPLimitInfo;
